import { JUMP_ACTIONS } from "@/consts/jumpLogic";
import { QUESTION_TYPE } from "@/consts/survey";

export default class Composite {
  createCompositeMetrics(categoryTree, surveyItemParent, lang, categoriesSelected) {
    for (const category of categoryTree) {
      for (const catUUID of categoriesSelected) {
        if (category.uuid === catUUID) {
          const categoryNameJson = {
            pt_BR: "",
            en_US: "",
            es_ES: ""
          };
          categoryNameJson[lang] = category.name;
          if (!surveyItemParent.items) {
            surveyItemParent.items = []; //remove composite metrics
          }
          // If category don't have children, create thumbs
          if (!category.children) {
            const item = this.createCompositeMetricsItem(QUESTION_TYPE.THUMBS, categoryNameJson, catUUID);
            surveyItemParent.items.push(item);
          } else {
            // If category has children, check if children is selected
            if (this.checkIfCategoryChildrenAreSelected(categoriesSelected, category.children)) {
              // If has children selected, create label and than create thumbs for children
              const label = this.createCompositeMetricsItem(
                QUESTION_TYPE.LABEL,
                categoryNameJson,
                catUUID,
                lang,
                categoriesSelected
              );
              surveyItemParent.items.push(label);
              // Create composite metric for children
              this.createCompositeMetrics(category.children, label, lang, categoriesSelected);
            } else {
              // If category do not have children selected, create thumbs
              const item = this.createCompositeMetricsItem(QUESTION_TYPE.THUMBS, categoryNameJson, catUUID);
              surveyItemParent.items.push(item);
            }
          }
        }
      }
    }
    return surveyItemParent;
  }

  createCompositeMetricsItem(type, categoryQuestion, categoryUUID) {
    let item = null;
    if (type === QUESTION_TYPE.LABEL) {
      item = {
        type: type,
        id: categoryUUID,
        question: { ...categoryQuestion },
        items: []
      };
    } else if (type === QUESTION_TYPE.THUMBS) {
      item = {
        type: type,
        weight: 0,
        id: categoryUUID,
        question: { ...categoryQuestion },
        promoter_enabled: true,
        detractor_enabled: true,
        neutral_enabled: true,
        category_uuid: categoryUUID,
        items: [],
        jump_rules_enabled: false,
        jump_rules: {
          detractor: {
            action: JUMP_ACTIONS.NEXT_QUESTION,
            value: null
          },
          passive: {
            action: JUMP_ACTIONS.NEXT_QUESTION,
            value: null
          },
          promoter: {
            action: JUMP_ACTIONS.NEXT_QUESTION,
            value: null
          }
        }
      };
    }
    return item;
  }

  /**
   * Check if children is selected
   * @param {category children} children
   */
  checkIfCategoryChildrenAreSelected(categories, children) {
    let selected = false;
    const categoriesSelected = categories;
    for (let i = 0; i < children.length; i++) {
      const category = children[i];
      for (let j = 0; j < categoriesSelected.length; j++) {
        const catUUID = categoriesSelected[j];
        if (category.uuid === catUUID) {
          selected = true;
          break;
        }
      }
    }
    return selected;
  }
}
